export const analyticsColors = [
  '#05A4D8',
  '#D3F5B9',
  '#C7F0FE',
  '#FFD200',
  '#D6DCE5',
  '#92D050',
  '#7BD5EB',
  '#767171',
  '#1F8A70',
  '#00B050',
  '#F8EE20',
  '#3CA789',
  '#70AD47',
  '#FFFF99',
  '#CFDF7A',
  '#FFA24E',
  '#FACBB4',
  '#9DF5B2',
  '#CCFF33',
  '#84DED2',
  '#8BA4D7',
  '#0089B4',
  '#35E6CC',
  '#3B3939',
  '#3E4D60',
  '#849780',
  '#A3F7EF',
  '#ABE8E9',
  '#3E89A9',
  '#0257BE',
  '#224D7C',
  '#046980',
  '#35D2FA',
  '#6CDBF9',
  '#88A4D7',
  '#99B2F7',
  '#BEDB39',
  '#59CAC3',
  '#B1073C',
  '#CF2F65',
  '#D1BEF6',
  '#660099',
  '#35D2FA',
  '#2436d9',
  '#1E2140',
  '#0B6CA6',
  '#B1A575',
  '#D95824',
  '#FFD930',
  '#3E6F7D',
  '#FF0000',
  '#45FFA6',
  '#59544F',
  '#A7B15A',
  '#CC5C60',
  '#5B726A',
  '#8B9B7F',
  '#F19077',
  '#14B7CA',
  '#9CD89C',
  '#FDFAE0',
  '#E6D2C0',
  '#FFD3E3',
  '#A53E45',
  '#BD4B5E',
  '#152324',
  '#F4DBC7',
  '#D78354',
  '#871B46',
  '#125D5E',
  '#283755',
  '#9E9900',
  '#EEEAEB',
  '#9A483B',
  '#60A4D7',
  '#2B2C19',
  '#E52312',
  '#333A58',
  '#273764',
  '#423A6E',
  '#4B5B7C',
  '#677B99',
  '#86E39F',
  '#C298BB',
  '#034245',
  '#2B2C19',
  '#DEC314',
  '#FFF3AC',
  '#D9043D',
  '#BF0A4C',
];
